import { Link } from "react-router-dom";
import { useI18n } from "@/saas/i18n";
import { BRAND } from "@/saas/config/brand";

export default function Footer() {
  const { t } = useI18n();
  const year = new Date().getFullYear();
  return (
    <footer className="relative mt-24 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-8 h-8 rounded-md bg-gold grid place-items-center text-black font-black text-sm">
              {BRAND.logo.text.charAt(0)}
            </span>
            <span className="font-display font-extrabold text-xl">{BRAND.logo.text}</span>
          </div>
          <p className="text-sm text-white/60 max-w-md leading-relaxed">{BRAND.tagline}</p>
        </div>
        <div>
          <div className="text-[10px] font-mono uppercase tracking-widest text-white/40 mb-3">Product</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/plans"   className="text-white/70 hover:text-gold">{t("nav.plans")}</Link></li>
            <li><Link to="/app"     className="text-white/70 hover:text-gold">{t("nav.app")}</Link></li>
            <li><Link to="/devices" className="text-white/70 hover:text-gold">{t("nav.devices")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-[10px] font-mono uppercase tracking-widest text-white/40 mb-3">Support</div>
          <ul className="space-y-2 text-sm">
            <li><a href={`mailto:${BRAND.supportEmail}`} className="text-white/70 hover:text-gold">{BRAND.supportEmail}</a></li>
            <li><a href="#" className="text-white/70 hover:text-gold">{t("footer.status")}</a></li>
            <li><a href="#" className="text-white/70 hover:text-gold">{t("footer.terms")}</a></li>
            <li><a href="#" className="text-white/70 hover:text-gold">{t("footer.privacy")}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 text-[11px] font-mono text-white/40">
          {t("footer.copyright", { year, brand: BRAND.logo.text })}
        </div>
      </div>
    </footer>
  );
}
